import { render, staticRenderFns } from "./assist_parameter.vue?vue&type=template&id=38d86e26&scoped=true"
import script from "./assist_parameter.vue?vue&type=script&lang=js"
export * from "./assist_parameter.vue?vue&type=script&lang=js"
import style0 from "./assist_parameter.vue?vue&type=style&index=0&id=38d86e26&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d86e26",
  null
  
)

export default component.exports